import styled from "styled-components";
import { hw } from "features/homework/homeworkUi";

interface Props {
    onSaveButtonClick: () => void;
    onDeleteButtonClick?: () => void;
}

const RegisterFooter = ({ onSaveButtonClick, onDeleteButtonClick }: Props) => {
    return (
        <Container>
            <ButtonGroup>
                <SaveButton type="button" onClick={onSaveButtonClick}>
                    저장
                </SaveButton>
                {onDeleteButtonClick && (
                    <DeleteButton type="button" onClick={onDeleteButtonClick}>
                        삭제
                    </DeleteButton>
                )}
            </ButtonGroup>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 14px 4px 4px;
    flex-shrink: 0;
`

const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
`

const Button = styled.button`
    padding: 11px 22px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    outline: none;
`

const SaveButton = styled(Button)`
    background: ${hw.brand};
    color: white;

    &:hover {
        background: ${hw.brandDark};
    }
`

const DeleteButton = styled(Button)`
    background: ${hw.surface};
    color: ${hw.brand};
    border: 1px solid ${hw.brandMuted};

    &:hover {
        background: ${hw.brandSoft};
    }
`

export default RegisterFooter;
